import * as CommanTypes from "./CommonTypes";
/**
 * @category Corners
 */
/**
 * @memberof module:Corner
 * @typedef {Object} KeyPointer
 * @property {Range} range - the range used by key pointer ex: h10:h22 or a10:k10
 * @property {string} keyPointer - key pointer name
 * @property {string} cornerArea - id of corner
 * @property {number} index - index of key pointer
 *
 * @example
 * const exampleData = {
 *   "range": [13, 14, 13, 27],
 *   "keyPointer": "Row",
 *   "cornerArea": "formula_01",
 *   "index": 0
 * };
 */

/**
 * @memberof module:Corner
 * @typedef { Object } Corner
 * @property { string } area - Id of corner
 * @property { number } sheetHfId - id of hyperformula sheet Ex: 0, 1, 2
 * @property { string } cornerType - type of corner ex: formula , style
 * @property { string } scope - scope of named range
 * @property { Range } columnRange - column range of corner
 * @property { Range } rowRange - row range of corner
 * @property { Record<string, KeyPointer[]> } columnKeyPointers - all column key pointers
 * @property { Record<string, KeyPointer[]> } rowKeyPointers -  all row key pointers
 
 * @example
 * const exampleData = {
 *   "area": "formula_01",
 *   "sheetHfId": 1,
 *   "cornerType": "formula",
 *   "scope": 1,
 *   "columnRange": [11, 8, 21, 12],
 *   "rowRange": [11, 8, 14, 24],
 *   "columnKeyPointers": {
 *     "sumlevel": [
 *       {
 *         "range": [13, 9, 13, 24],
 *         "keyPointer": "sumlevel",
 *         "dimension": "column",
 *         "cornerArea": "formula_01",
 *         "index": 0
 *       }
 *     ],
 *   },
 *   "rowKeyPointers": {
 *     "sum": [
 *       {
 *         "range": [12, 9, 21, 9],
 *         "keyPointer": "sum",
 *         "dimension": "row",
 *         "cornerArea": "formula_01",
 *         "index": 0
 *       }
 *     ]
 *   }
 * };
 */

/**
 * @typedef { Record<string, Corner>} Corners
 */

/**
 * @memberof module:Corner
 * @typedef {Object} SumLevelCalc
 * @property { CommanTypes.Range} range -
 * @property { CommanTypes.Range[]} parameters
 */

/**
 * @memberof module:Corner
 * @typedef {Object} Change
 * @property {number[]} row - Indices of the rows that were changed.
 * @property {number[]} column - Indices of the columns that were changed.
 * @example
 * {
 *  row: [30,31],
 *  column: [20,22]
 * }
 */

/**
 * @memberof module:Corner
 * @typedef {Record<string, Change>} Changes
 * A mapping of change indices to their corresponding Change objects.
 * The key is a string representing the change index.
 * @example
 * {
 *  0: {
 *      row: [30,31],
 *      column: [20,22]
 *  },
 *  1: {
 *      row: [10,11],
 *      column: []
 *  }
 * }
 */

/**
 * @memberof module:Corner
 * @typedef { Record<string, Changes>} KeyPointerChangeMap
 *
 * A nested object representing changes in key pointers for a corner.
 *
 * @example
 * {
 *  Data: {
 *      0: {
 *          row: [30,31],
 *          column: [20,22]
 *      }
 *  },
 *  Header: {
 *      0: {
 *         row: [],
 *         column: [33,34]
 *      }
 *  }
 * }
 */

/**
 * @memberof module:Corner
 * @typedef {Record<string, KeyPointerChangeMap >} CornerKeyPointerChangeMap
 *
 * A nested object representing changes in key pointers for multiple corners.
 */

export const Types = {};
